import {Component, Input} from '@angular/core';
import {RouterLink, RouterLinkActive, RouterOutlet} from "@angular/router";
import {MatTab, MatTabContent, MatTabGroup} from "@angular/material/tabs";
import {ClientDetailsComponent} from "../../customs/_components/manage-clients/client-details/client-details.component";
import {MatCard} from "@angular/material/card";
import {CustomizerSettingsService} from "../../customizer-settings/customizer-settings.service";
import {
    ClientsPocDetailsComponent
} from "../../customs/_components/manage-clients-poc/clients-poc-details/clients-poc-details.component";
import {
    ClientsExploitationDetailsComponent
} from "../../customs/_components/manage-clients-exploitation/clients-exploitation-details/clients-exploitation-details.component";
import {
    ClientsTerrainDetailsComponent
} from "../../customs/_components/manage-clients-terrain/clients-terrain-details/clients-terrain-details.component";
import {
    ClientsSampleDetailsComponent
} from "../../customs/_components/manage-samplers/clients-sample-details/clients-sample-details.component";
import { ClientsRapportDetailsComponent } from '../../customs/_components/report/clients-rapport-details/clients-rapport-details.component';

@Component({
  selector: 'app-navbar-clients-details',
  standalone: true,
    providers: [CustomizerSettingsService],
    imports: [
        RouterLink,
        RouterLinkActive,
        MatTabGroup,
        MatTab,
        RouterOutlet,
        MatTabContent,
        ClientDetailsComponent,
        MatCard,
        ClientsPocDetailsComponent,
        ClientsExploitationDetailsComponent,
        ClientsTerrainDetailsComponent,
        ClientsSampleDetailsComponent,
        ClientsRapportDetailsComponent
    ],
  templateUrl: './navbar-clients-details.component.html',
  styleUrl: './navbar-clients-details.component.scss'
})
export class NavbarClientsDetailsComponent {
    @Input() id! : string;


    constructor(public themeService: CustomizerSettingsService) {
    }
}
